import { stories } from "@/mocks/home";

export default function Stories() {
  return (
    <section id="stories" className="anchor-offset">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
        <div className="mb-10 flex flex-col gap-3 md:max-w-2xl">
          <span className="text-xs font-medium uppercase tracking-widest text-primary-600">会员故事</span>
          <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">
            他们的缘分，从一个群里的一句回复开始
          </h2>
          <p className="text-sm leading-relaxed text-foreground-700 md:text-base">
            下面是一些会员愿意分享的经历。每个人的节奏不同，但共同点是：先放下目的，认真聊一次天。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
          {stories.map((story) => (
            <figure
              key={story.names}
              className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                <i className="ri-double-quotes-l text-xl" aria-hidden="true"></i>
              </span>
              <blockquote className="text-sm leading-relaxed text-foreground-700">{story.quote}</blockquote>
              <figcaption className="mt-auto flex items-center justify-between border-t border-background-200 pt-4">
                <span className="flex flex-col">
                  <span className="font-heading text-base text-foreground-950">{story.names}</span>
                  <span className="inline-flex items-center gap-1 text-xs text-foreground-600">
                    <i className="ri-map-pin-line" aria-hidden="true"></i>
                    {story.city}
                  </span>
                </span>
                <span className="rounded-full bg-accent-100 px-2.5 py-1 text-[11px] font-medium text-accent-800">
                  {story.highlight}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>

        <p className="mt-6 text-xs leading-relaxed text-foreground-600">
          以上内容为会员自愿分享的经历，真实关系发展因人而异，请以理性、安全的态度对待每一次相识。
        </p>
      </div>
    </section>
  );
}